import { createContext } from 'react';

/**
 * Internal, exported only for usage in Framer
 */
const SwitchLayoutGroupContext = createContext({});
export { SwitchLayoutGroupContext };